



var $b825b3b637252d95$exports = {};
$b825b3b637252d95$exports = import.meta.resolve("aYQdk");


const $59088782b3ab5f20$var$logoUrl = new URL($b825b3b637252d95$exports).href;
function $59088782b3ab5f20$export$8b251419efc915eb() {
    return `
    <header class="header">
      <div class="container">
        <nav class="nav">

	  			<a href="#/" class="logo">
            <img src="${$59088782b3ab5f20$var$logoUrl}" alt="Logo" />
          </a>

	  			<ul class="nav__list">
	    			<li><a href="#/" class="nav_link">Home</a></li>
	    			<li><a href="#/tech-specs" class="nav_link">Tech Specs</a></li>
	    			<li><a href="#/compare" class="nav_link">Compare</a></li>
          </ul>

	  			<div class="nav__icon">                                                                  
	    			<button class="mobile-nav-btn">
	      			<div class="nav-icon"></div>
	    			</button>
	  			</div>

        </nav>
      </div>
    </header>

    <div class="mobile-nav">                                                                        
      <ul class="mobile-nav__list">
        <li><a href="#/">Home</a></li>
				<li><a href="#/tech-specs">Tech Specs</a></li>
				<li><a href="#/compare">Compare</a></li>
      </ul>
    </div>
  `;
}





const $f0715d72829b3571$var$logoUrl = new URL($b825b3b637252d95$exports).href;
var $8fbf1a7915cca6eb$exports = {};
$8fbf1a7915cca6eb$exports = import.meta.resolve("c7TJV");


const $f0715d72829b3571$var$discordUrl = new URL($8fbf1a7915cca6eb$exports).href;
var $4f5fe146ea8c378b$exports = {};
$4f5fe146ea8c378b$exports = import.meta.resolve("3scE4");


const $f0715d72829b3571$var$metaUrl = new URL($4f5fe146ea8c378b$exports).href;
var $519b53024cba55c0$exports = {};
$519b53024cba55c0$exports = import.meta.resolve("70jJ5");


const $f0715d72829b3571$var$xUrl = new URL($519b53024cba55c0$exports).href;
function $f0715d72829b3571$export$a06f1c675e846f6f() {
    return `
    <footer class="footer">
      <div class="container">
        <p class="footer_title">Sound. Presence. Purpose.</p>
				<p class="footer_text">
					Focused on crafting immersive audio experiences.<br />
					We believe sound should not just be heard\u{2014}it should move you.
				</p>
				<div class="footer_buttons">
					<a href="#!" class="footer_btn">Aura Pro II</a>
					<a href="#!" class="footer_btn">Flow II</a>
				</div>
				<div class="footer_sub">
					<a href="#/" class="footer_logo">
						<img src="${$f0715d72829b3571$var$logoUrl}" alt="Logo" />
					</a>
					<div class="sicial_block">
						<p class="copyright">\xa9 2025 Resonance. All rights reserved.</p>
						<div class="footer_socials">
							<a href="#!">
								<img src="${$f0715d72829b3571$var$discordUrl}" alt="Discord" />
							</a>
							<a href="#!">
								<img src="${$f0715d72829b3571$var$xUrl}" alt="X" />
							</a>
							<a href="#!">
								<img src="${$f0715d72829b3571$var$metaUrl}" alt="Meta" />
							</a>
						</div>
					</div>
				</div>
      </div>
    </footer>
  `;
}






var $24913df3a2646410$exports = {};
$24913df3a2646410$exports = import.meta.resolve("lWSE0");


const $9a27900de76c9d64$var$headphoneUrl = new URL($24913df3a2646410$exports).href;
var $7d2a9f77200c8b3c$exports = {};
$7d2a9f77200c8b3c$exports = import.meta.resolve("iTRBr");


const $9a27900de76c9d64$var$headphone_2xUrl = new URL($7d2a9f77200c8b3c$exports).href;
function $9a27900de76c9d64$export$887967f05dc521ae() {
    return `
    <section class="hero">
      <div class="container">
        <h1 class="hero_title">Resonance</h1>
				<picture>
					<source srcset="${$9a27900de76c9d64$var$headphoneUrl} 1x, ${$9a27900de76c9d64$var$headphone_2xUrl} 2x" type="image/jpeg" />
					<img src="${$9a27900de76c9d64$var$headphoneUrl}" alt="Hero" class="hero__img" />
				</picture>
				<p class="hero_back">Aura Pro II</p>
      </div>
    </section>
  `;
}




function $c5f617aa582c64a2$export$99e00de73f33b819(rootSelector = ".carousel") {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    // Проверяем, не инициализирован ли уже
    if (root.dataset.carouselInit === "1") return;
    root.dataset.carouselInit = "1";
    const track = root.querySelector(".carousel__track");
    const cards = track ? Array.from(track.querySelectorAll(".card-container")) : [];
    const dots = Array.from(root.querySelectorAll(".carousel-pagination .dot"));
    if (!track || !cards.length) return;
    let activeIndex = Math.floor(cards.length / 2);
    const update = ()=>{
        cards.forEach((card, i)=>{
            card.classList.remove("prev", "active", "next");
            if (i === activeIndex) card.classList.add("active");
            else if (i === (activeIndex - 1 + cards.length) % cards.length) card.classList.add("prev");
            else if (i === (activeIndex + 1) % cards.length) card.classList.add("next");
        });
        dots.forEach((dot, i)=>dot.classList.toggle("active", i === activeIndex));
    };
    const goTo = (index)=>{
        activeIndex = (index + cards.length) % cards.length;
        update();
    };
    // Навигация по точкам
    dots.forEach((dot)=>{
        dot.addEventListener("click", ()=>{
            const idx = Number(dot.dataset.index);
            if (!Number.isNaN(idx)) goTo(idx);
        });
    });
    // Первичная отрисовка
    update();
    // Возвращаем функцию для удаления событий при уходе со страницы
    return function destroyCarousel() {
        root.dataset.carouselInit = "0";
        dots.forEach((dot)=>{
            const clone = dot.cloneNode(true);
            dot.replaceWith(clone);
        });
    };
}


var $dce9e95b45f121f4$exports = {};
$dce9e95b45f121f4$exports = import.meta.resolve("659pi");


const $d07fbe82281e490c$var$carousel_1Url = new URL($dce9e95b45f121f4$exports).href;
var $70f8fd6e4513fc93$exports = {};
$70f8fd6e4513fc93$exports = import.meta.resolve("1k3F0");


const $d07fbe82281e490c$var$carousel_2Url = new URL($70f8fd6e4513fc93$exports).href;
var $eec1a4ea974c457e$exports = {};
$eec1a4ea974c457e$exports = import.meta.resolve("bZa42");


const $d07fbe82281e490c$var$carousel_3Url = new URL($eec1a4ea974c457e$exports).href;
let $d07fbe82281e490c$var$carouselDestroy = null;
function $d07fbe82281e490c$export$144901db2ea8e967() {
    const markup = `
    <section class="carousel">
      <div class="container">
        <h2 class="carousel_title">Your Style. Your Sound.</h2>
        <p class="carousel_text">
          Studio-grade acoustics that dissolve distractions and awaken clarity.
        </p>
        <div class="slider_carousel">
          <div class="carousel__track">
            <div class="card-container">
              <div class="card">
                <img src="${$d07fbe82281e490c$var$carousel_1Url}" alt="Yellow headphones">
              </div>
            </div>
            <div class="card-container">
              <div class="card">
                <img src="${$d07fbe82281e490c$var$carousel_2Url}" alt="Green headphones">
              </div>
            </div>
            <div class="card-container">
              <div class="card">
                <img src="${$d07fbe82281e490c$var$carousel_3Url}" alt="Red headphones">
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-pagination">
          <span class="dot yellow active" data-index="0"></span>
          <span class="dot green" data-index="1"></span>
          <span class="dot red" data-index="2"></span>
        </div>
        <p class="color_text">Choose a color that fits your flow.</p>
      </div>
    </section>
  `;
    requestAnimationFrame(()=>{
        if (typeof $d07fbe82281e490c$var$carouselDestroy === "function") {
            try {
                $d07fbe82281e490c$var$carouselDestroy();
            } catch (e) {}
            $d07fbe82281e490c$var$carouselDestroy = null;
        }
        $d07fbe82281e490c$var$carouselDestroy = (0, $c5f617aa582c64a2$export$99e00de73f33b819)(".carousel");
    });
    return markup;
}




function $ba886d07ad7f5144$export$502d9fa3c88d6e5f(rootSelector = ".features-slider") {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    // предотвращаем повторную инициализацию
    if (root.dataset.featuresInit === "1") return;
    root.dataset.featuresInit = "1";
    const track = root.querySelector(".features-track");
    if (!track) return;
    let isDown = false;
    let startX;
    let scrollLeft;
    // --- drag мышкой ---
    const startDragging = (e)=>{
        isDown = true;
        track.classList.add("grabbing");
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
    };
    const stopDragging = ()=>{
        isDown = false;
        track.classList.remove("grabbing");
    };
    const move = (e)=>{
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1; // скорость реакции
        track.scrollLeft = scrollLeft - walk;
    };
    track.addEventListener("mousedown", startDragging);
    track.addEventListener("mouseleave", stopDragging);
    track.addEventListener("mouseup", stopDragging);
    track.addEventListener("mousemove", move);
    // --- drag на тач-устройствах ---
    let touchStartX = 0;
    let touchScrollLeft = 0;
    const onTouchStart = (e)=>{
        touchStartX = e.touches[0].pageX - track.offsetLeft;
        touchScrollLeft = track.scrollLeft;
    };
    const onTouchMove = (e)=>{
        const x = e.touches[0].pageX - track.offsetLeft;
        const walk = (x - touchStartX) * 1;
        track.scrollLeft = touchScrollLeft - walk;
    };
    track.addEventListener("touchstart", onTouchStart, {
        passive: true
    });
    track.addEventListener("touchmove", onTouchMove, {
        passive: true
    });
    track.addEventListener("dragstart", (e)=>e.preventDefault());
    console.log("\u2705 Features slider initialized");
    // Возвращаем destroy-функцию
    return function destroyFeaturesSlider() {
        root.dataset.featuresInit = "0";
        // снимаем все слушатели без утечек
        track.removeEventListener("mousedown", startDragging);
        track.removeEventListener("mouseleave", stopDragging);
        track.removeEventListener("mouseup", stopDragging);
        track.removeEventListener("mousemove", move);
        track.removeEventListener("touchstart", onTouchStart);
        track.removeEventListener("touchmove", onTouchMove);
        console.log("\uD83E\uDDF9 Features slider destroyed");
    };
}


var $608c347801ef8587$exports = {};
$608c347801ef8587$exports = import.meta.resolve("6O5nS");


const $7e43633236895790$var$featuresUrl = new URL($608c347801ef8587$exports).href;
var $3cb3c6fa67f50d5b$exports = {};
$3cb3c6fa67f50d5b$exports = import.meta.resolve("6gkmd");


const $7e43633236895790$var$features_mobileUrl = new URL($3cb3c6fa67f50d5b$exports).href;
const $7e43633236895790$var$featuresSlides = [
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    },
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    },
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    },
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    },
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    },
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    },
    {
        text: "Deep lows. Lush mids. Airy highs. All perfectly in balance.",
        img: $7e43633236895790$var$featuresUrl,
        imgMobile: $7e43633236895790$var$features_mobileUrl
    }
];
let $7e43633236895790$var$featuresDestroy = null;
function $7e43633236895790$export$617d79dae526d2cf() {
    const slidesMarkup = $7e43633236895790$var$featuresSlides.map((slide, i)=>`
      <div class="features-slide ${i % 2 === 1 ? "two" : ""}">
        <div class="features-card">
          <p>${slide.text}</p>
          <picture>
            <source srcset="${slide.imgMobile}" media="(max-width: 900px)">
            <img src="${slide.img}" alt="Feature ${i + 1}">
          </picture>
        </div>
      </div>
    `).join("");
    const markup = `
    <section class="features">
      <div class="container">
        <div class="features-slider">
          <div class="features-track">
            ${slidesMarkup}
          </div>
        </div>
      </div>
    </section>
  `;
    requestAnimationFrame(()=>{
        if (typeof $7e43633236895790$var$featuresDestroy === "function") {
            try {
                $7e43633236895790$var$featuresDestroy();
            } catch (e) {}
            $7e43633236895790$var$featuresDestroy = null;
        }
        $7e43633236895790$var$featuresDestroy = (0, $ba886d07ad7f5144$export$502d9fa3c88d6e5f)(".features-slider");
    });
    return markup;
}




function $cb6caab895a14e94$export$e1e595f9757ffaa0(rootSelector = ".personalize-slider") {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    // предотвращаем повторную инициализацию
    if (root.dataset.personalizeInit === "1") return;
    root.dataset.personalizeInit = "1";
    const track = root.querySelector(".personalize-track");
    if (!track) return;
    let isDown = false;
    let startX;
    let scrollLeft;
    // --- drag мышкой ---
    const startDragging = (e)=>{
        isDown = true;
        track.classList.add("grabbing");
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
    };
    const stopDragging = ()=>{
        isDown = false;
        track.classList.remove("grabbing");
    };
    const move = (e)=>{
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1; // скорость реакции
        track.scrollLeft = scrollLeft - walk;
    };
    track.addEventListener("mousedown", startDragging);
    track.addEventListener("mouseleave", stopDragging);
    track.addEventListener("mouseup", stopDragging);
    track.addEventListener("mousemove", move);
    // --- drag на тач-устройствах ---
    let touchStartX = 0;
    let touchScrollLeft = 0;
    const onTouchStart = (e)=>{
        touchStartX = e.touches[0].pageX - track.offsetLeft;
        touchScrollLeft = track.scrollLeft;
    };
    const onTouchMove = (e)=>{
        const x = e.touches[0].pageX - track.offsetLeft;
        const walk = (x - touchStartX) * 1;
        track.scrollLeft = touchScrollLeft - walk;
    };
    track.addEventListener("touchstart", onTouchStart, {
        passive: true
    });
    track.addEventListener("touchmove", onTouchMove, {
        passive: true
    });
    track.addEventListener("dragstart", (e)=>e.preventDefault());
    console.log("\u2705 Personalize slider initialized");
    // Возвращаем destroy-функцию
    return function destroyPersonalizeSlider() {
        root.dataset.personalizeInit = "0";
        // снимаем все слушатели без утечек
        track.removeEventListener("mousedown", startDragging);
        track.removeEventListener("mouseleave", stopDragging);
        track.removeEventListener("mouseup", stopDragging);
        track.removeEventListener("mousemove", move);
        track.removeEventListener("touchstart", onTouchStart);
        track.removeEventListener("touchmove", onTouchMove);
        console.log("\uD83E\uDDF9 Personalize slider destroyed");
    };
}


var $e5ac8f3c11b8d094$exports = {};
$e5ac8f3c11b8d094$exports = import.meta.resolve("bGLn3");


const $e25f3dcada3f4254$var$personalize_1Url = new URL($e5ac8f3c11b8d094$exports).href;
var $c97e8214da16c82b$exports = {};
$c97e8214da16c82b$exports = import.meta.resolve("b8wkN");


const $e25f3dcada3f4254$var$personalize_2Url = new URL($c97e8214da16c82b$exports).href;
var $c412872b635c0fae$exports = {};
$c412872b635c0fae$exports = import.meta.resolve("3VzwE");


const $e25f3dcada3f4254$var$personalize_3Url = new URL($c412872b635c0fae$exports).href;
const $e25f3dcada3f4254$var$personalizeSlides = [
    {
        img: $e25f3dcada3f4254$var$personalize_1Url
    },
    {
        img: $e25f3dcada3f4254$var$personalize_2Url
    },
    {
        img: $e25f3dcada3f4254$var$personalize_3Url
    },
    {
        img: $e25f3dcada3f4254$var$personalize_1Url
    },
    {
        img: $e25f3dcada3f4254$var$personalize_2Url
    },
    {
        img: $e25f3dcada3f4254$var$personalize_3Url
    },
    {
        img: $e25f3dcada3f4254$var$personalize_1Url
    }
];
let $e25f3dcada3f4254$var$personalizeDestroy = null;
function $e25f3dcada3f4254$export$41c6104d68145ae7() {
    const slidesMarkup = $e25f3dcada3f4254$var$personalizeSlides.map((slide, i)=>`
      <div class="personalize-slide ${i % 2 === 1 ? "two" : ""}">
        <div class="personalize-card">
          <img src="${slide.img}" alt="Personalize ${i + 1}">
        </div>
      </div>
    `).join("");
    const markup = `
    <section class="personalize">
      <div class="container">
				<h2 class="personalize_title">Every Detail matters</h2>
				<p class="personalize_text">From the stitch to the signal, precision lives here.</p>
        <div class="personalize-slider">
          <div class="personalize-track">
            ${slidesMarkup}
          </div>
        </div>
      </div>
    </section>
  `;
    requestAnimationFrame(()=>{
        if (typeof $e25f3dcada3f4254$var$personalizeDestroy === "function") {
            try {
                $e25f3dcada3f4254$var$personalizeDestroy();
            } catch (e) {}
            $e25f3dcada3f4254$var$personalizeDestroy = null;
        }
        $e25f3dcada3f4254$var$personalizeDestroy = (0, $cb6caab895a14e94$export$e1e595f9757ffaa0)(".personalize-slider");
    });
    return markup;
}




function $8447f13afecfa743$export$d7a01e11500dfb6f() {
    return `
    <section class="sub">
			<div class="container">
				<p class="sub_text">Dreamlike Sound</p>
				<p class="sub_price">Starting at $320 \u{2014} Available Now.</p>
				<button class="sub_btn">Buy Now</button>
			</div>
		</section>
  `;
}




function $870eae4dd670dbea$export$b94310965bed44e6() {
    return `
    ${(0, $9a27900de76c9d64$export$887967f05dc521ae)()}                                                                                      
    ${(0, $d07fbe82281e490c$export$144901db2ea8e967)()}                                                                                      
    ${(0, $7e43633236895790$export$617d79dae526d2cf)()}                                                                                      
    ${(0, $e25f3dcada3f4254$export$41c6104d68145ae7)()}                                                                                      
    ${(0, $8447f13afecfa743$export$d7a01e11500dfb6f)()}                                                                                      
  `;
}




function $396bdc9d884723a6$export$357222452e0f311c(rootSelector = ".top") {
    if (typeof window === "undefined") return ()=>{};
    const root = document.querySelector(rootSelector);
    if (!root) return ()=>{};
    // Если уже инициализировано — вернём функцию destroy (никаких дублей)
    if (root.dataset.topInit === "1") return ()=>{}; // noop destroy
    root.dataset.topInit = "1";
    const slides = Array.from(root.querySelectorAll(".top_slide"));
    const dots = Array.from(root.querySelectorAll(".top_dots .dot"));
    if (!slides.length || !dots.length) {
        // если нет нужных элементов — очистим флаг и выйдем
        delete root.dataset.topInit;
        return ()=>{};
    }
    let activeIndex = Math.floor(slides.length / 2);
    let isAnimating = false;
    const ANIM_MS = 320;
    function showSlide(index) {
        if (isAnimating || index === activeIndex) return;
        isAnimating = true;
        const current = slides[activeIndex];
        const next = slides[index];
        current.classList.remove("active");
        current.classList.add("fade-out");
        next.classList.add("fade-in");
        dots[activeIndex].classList.remove("active");
        dots[index].classList.add("active");
        setTimeout(()=>{
            current.classList.remove("fade-out");
            next.classList.remove("fade-in");
            next.classList.add("active");
            activeIndex = index;
            isAnimating = false;
        }, ANIM_MS);
    }
    const onDotClick = (e)=>{
        const dot = e.currentTarget;
        const idx = parseInt(dot.dataset.index, 10);
        if (!Number.isNaN(idx)) showSlide(idx);
    };
    dots.forEach((d)=>d.addEventListener("click", onDotClick));
    // вернуть destroy функцию — снимает слушатели и флаг и позволяет корректную реинициализацию
    const destroy = ()=>{
        dots.forEach((d)=>d.removeEventListener("click", onDotClick));
        delete root.dataset.topInit;
    };
    return destroy;
}


var $ee5d17f3ac33cdd2$exports = {};
$ee5d17f3ac33cdd2$exports = import.meta.resolve("jT6kq");


const $b51b3b7663d1177d$var$top_1Url = new URL($ee5d17f3ac33cdd2$exports).href;
var $18e1682868b23d54$exports = {};
$18e1682868b23d54$exports = import.meta.resolve("77co0");


const $b51b3b7663d1177d$var$top_2Url = new URL($18e1682868b23d54$exports).href;
var $e33a0bce2897f26f$exports = {};
$e33a0bce2897f26f$exports = import.meta.resolve("gHB89");


const $b51b3b7663d1177d$var$top_3Url = new URL($e33a0bce2897f26f$exports).href;
var $e64bf6b4cbff34f3$exports = {};
$e64bf6b4cbff34f3$exports = import.meta.resolve("fD8lt");


const $b51b3b7663d1177d$var$top_mobile_1Url = new URL($e64bf6b4cbff34f3$exports).href;
var $8b5bada5a381786a$exports = {};
$8b5bada5a381786a$exports = import.meta.resolve("kutiB");


const $b51b3b7663d1177d$var$top_mobile_2Url = new URL($8b5bada5a381786a$exports).href;
var $200fbfc136f10a1e$exports = {};
$200fbfc136f10a1e$exports = import.meta.resolve("3kZT9");


const $b51b3b7663d1177d$var$top_mobile_3Url = new URL($200fbfc136f10a1e$exports).href;
let $b51b3b7663d1177d$var$topDestroy = null;
function $b51b3b7663d1177d$export$b5738e83c092973d() {
    const markup = `
    <section class="top">
      <div class="container">
        <div class="top_color">
          <p class="top_text">Color</p>
					<div class="slider_block">
          	<div class="top_slider">
            	<div class="top_slide">
              	<picture>
            			<source srcset="${$b51b3b7663d1177d$var$top_mobile_1Url}" media="(max-width: 768px)">
            			<img src="${$b51b3b7663d1177d$var$top_1Url}" alt="Yellow headphones">
          			</picture>
            	</div>
            	<div class="top_slide active">
              	<picture>
            			<source srcset="${$b51b3b7663d1177d$var$top_mobile_2Url}" media="(max-width: 768px)">
            			<img src="${$b51b3b7663d1177d$var$top_2Url}" alt="Green headphones">
          			</picture>
            	</div>
            	<div class="top_slide">
              	<picture>
            			<source srcset="${$b51b3b7663d1177d$var$top_mobile_3Url}" media="(max-width: 768px)">
            			<img src="${$b51b3b7663d1177d$var$top_3Url}" alt="Red headphones">
          			</picture>
            	</div>
          	</div>
						<div class="top_dots">
            	<span class="dot" data-index="0" style="background:#D8B74B;"></span>
            	<span class="dot active" data-index="1" style="background:#94915B;"></span>
            	<span class="dot" data-index="2" style="background:#883D39;"></span>
          	</div>
					</div>
        </div>
      </div>
    </section>
  `;
    requestAnimationFrame(()=>{
        if (typeof $b51b3b7663d1177d$var$topDestroy === "function") {
            try {
                $b51b3b7663d1177d$var$topDestroy();
            } catch (e) {}
            $b51b3b7663d1177d$var$topDestroy = null;
        }
        $b51b3b7663d1177d$var$topDestroy = (0, $396bdc9d884723a6$export$357222452e0f311c)(".top");
    });
    return markup;
}




function $90132d63db5b795f$export$2ca40b36e248d283() {
    return `
    <section class="features_tech">
      <div class="tech_specs_content">
					<div class="tech_specs_block">
						<p class="tech_title">Audio Technology</p>
						<p class="tech_text">
							Custom-tuned 40mm Resonance\u{2122} drivers for deep bass.<br />
							Ultra-low distortion signal processing.<br />
							Adaptive Sound Sculpting\u{2122} \u{2014} real-time EQ.<br />
							Spatial Audio Calibration with dynamic head tracking.<br />
							Natural Voice Isolation for calls, focus, and immersive listening.<br />
							Pressure-balancing acoustic vents for long-wear comfort.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Intelligence</p>
						<p class="tech_text">
							Dual noise-targeting microphones.<br />
							Internal ear-position mic for personalized audio tuning.<br />
							Proximity & motion sensors to detect wear and usage.<br />
							Gesture-aware force sensor for effortless control.<br />
							Accelerometer-assisted voice capture for clarity on the move.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Power</p>
						<p class="tech_text">
							Custom-designed <span>R2 Sound Core</span> chip.<br />
							Advanced audio algorithms tuned for emotional clarity.<br />
							Onboard neural audio engine for Spatial Audio and Adaptive EQ.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Controls</p>
						<p class="tech_text">
							Tap once to play/pause or answer a call.<br />
							Tap twice to skip forward or end a call.<br />
							Tap three times to rewind.<br />
							Press and hold to access voice assistant.<br />
							Automatic mute when removed, smart resume when worn.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Built for the Elements</p>
						<p class="tech_text">
							Rated <span>IPX4</span> for sweat and weather resistance.<br />
							Designed for long sessions, light activity, or relaxed stillness.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Battery</p>
						<p class="tech_text">
							Up to <span>36 hours</span> total listening time with case.<br />
							Up to <span>6.5 hours</span> on a single charge.<br />
							Fast charge: <span>10 minutes = 2 hours of play.</span><br />
							USB-C charging + Qi-compatible wireless charging.<br />
							LED status light + Find My compatible tone alert.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Connectivity</p>
						<p class="tech_text">
							Bluetooth\xae 5.3 low-latency audio.<br />
							Multipoint connection with auto handoff.<br />
							Seamless pairing across all your devices.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Materials</p>
						<p class="tech_text">
							100% recycled aluminum in internal frames.<br />
							Bio-based mesh ear padding.<br />
							Rare earth magnets sourced from reclaimed materials.<br />
							Plastic-free, fiber-based packaging.<br />
							Assembled in Zero Waste-certified facilities.<br />
						</p>
					</div>
					<div class="tech_specs_block">
						<p class="tech_title">Sustainability & Materials</p>
						<p class="tech_text">
							100% recycled aluminum in internal frames.<br />
							Bio-based mesh ear padding.<br />
							Rare earth magnets sourced from reclaimed materials.<br />
							Plastic-free, fiber-based packaging.<br />
							Assembled in Zero Waste-certified facilities.<br />
						</p>
					</div>
				</div>
    </section>
  `;
}




function $65978aa46d2623c0$export$d1b34e3401ad4ae9() {
    return `
    ${(0, $b51b3b7663d1177d$export$b5738e83c092973d)()}                                                                                      
    ${(0, $90132d63db5b795f$export$2ca40b36e248d283)()}    
  `;
}




var $29c20058d6be9396$exports = {};
$29c20058d6be9396$exports = import.meta.resolve("h4Xjm");


const $7d2e3f27b298a1f5$var$model_1Url = new URL($29c20058d6be9396$exports).href;
var $5c4221fac03b893d$exports = {};
$5c4221fac03b893d$exports = import.meta.resolve("jOsUM");


const $7d2e3f27b298a1f5$var$model_2Url = new URL($5c4221fac03b893d$exports).href;
var $9e701d25dbf02644$exports = {};
$9e701d25dbf02644$exports = import.meta.resolve("7oSY9");


const $7d2e3f27b298a1f5$var$batteryUrl = new URL($9e701d25dbf02644$exports).href;
var $2aaa75f57925d762$exports = {};
$2aaa75f57925d762$exports = import.meta.resolve("hRlNE");


const $7d2e3f27b298a1f5$var$cpuUrl = new URL($2aaa75f57925d762$exports).href;
var $b20e7d58d09372e3$exports = {};
$b20e7d58d09372e3$exports = import.meta.resolve("8tE4z");


const $7d2e3f27b298a1f5$var$dropUrl = new URL($b20e7d58d09372e3$exports).href;
var $fb8fc90bf6a0d936$exports = {};
$fb8fc90bf6a0d936$exports = import.meta.resolve("Pt9n5");


const $7d2e3f27b298a1f5$var$earUrl = new URL($fb8fc90bf6a0d936$exports).href;
var $57981e58f31a8615$exports = {};
$57981e58f31a8615$exports = import.meta.resolve("ljO7q");


const $7d2e3f27b298a1f5$var$equalizerUrl = new URL($57981e58f31a8615$exports).href;
var $6d064f93039d9680$exports = {};
$6d064f93039d9680$exports = import.meta.resolve("blSOU");


const $7d2e3f27b298a1f5$var$microphoneUrl = new URL($6d064f93039d9680$exports).href;
var $ebb2798277ba5702$exports = {};
$ebb2798277ba5702$exports = import.meta.resolve("93D64");


const $7d2e3f27b298a1f5$var$minusUrl = new URL($ebb2798277ba5702$exports).href;
var $9e06b3c0de4cf604$exports = {};
$9e06b3c0de4cf604$exports = import.meta.resolve("kI3M0");


const $7d2e3f27b298a1f5$var$simpleUrl = new URL($9e06b3c0de4cf604$exports).href;
var $089ae3797438637f$exports = {};
$089ae3797438637f$exports = import.meta.resolve("itMTf");


const $7d2e3f27b298a1f5$var$tapUrl = new URL($089ae3797438637f$exports).href;
var $43b0dc8a35c8de4c$exports = {};
$43b0dc8a35c8de4c$exports = import.meta.resolve("aj4J1");


const $7d2e3f27b298a1f5$var$userUrl = new URL($43b0dc8a35c8de4c$exports).href;
function $7d2e3f27b298a1f5$export$6edbc060ce567afa() {
    return `
    <section class="models">
			<div class="container">
				<h2 class="models_title">Compare Resonance models</h2>
				<p class="models_text">Get help choosing. Chat with a Specialist.</p>
				<div class="models_block">
					<div class="models_card">
						<div class="models_img_block">
							<p class="models_img_title">Aura Pro II</p>
							<img src="${$7d2e3f27b298a1f5$var$model_1Url}" alt="Headphones">
							<p class="models_price">Starting at $320</p>
							<button class="models_btn">Buy Now</button>
						</div>
						<div class="compare_content">
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$cpuUrl}" alt="Icon">
								<p class="compare_text">R1 Chip</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$simpleUrl}" alt="Icon">
								<p class="compare_text">2x more Active Noise Cancellation</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$userUrl}" alt="Icon">
								<p class="compare_text">Personalized Spatial Audio</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$equalizerUrl}" alt="Icon">
								<p class="compare_text">Lossless Audio</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$minusUrl}" alt="Icon">
								<p class="compare_text">None</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$minusUrl}" alt="Icon">
								<p class="compare_text">None</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$batteryUrl}" alt="Icon">
								<p class="compare_text">Up to 17 hours of listening</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$minusUrl}" alt="Icon">
								<p class="compare_text">None</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$microphoneUrl}" alt="Icon">
								<p class="compare_text">5 microphones total</p>
							</div>
						</div>
					</div>

					<div class="models_card">
						<div class="models_img_block">
							<p class="models_img_title">Flow II</p>
							<img src="${$7d2e3f27b298a1f5$var$model_2Url}" alt="Headphones">
							<p class="models_price">Starting at $160</p>
							<button class="models_btn">Buy Now</button>
						</div>
						<div class="compare_content">
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$cpuUrl}" alt="Icon">
								<p class="compare_text">R2 Chip</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$simpleUrl}" alt="Icon">
								<p class="compare_text">Active Noise Cancellation</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$userUrl}" alt="Icon">
								<p class="compare_text">Personalized Spatial Audio</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$minusUrl}" alt="Icon">
								<p class="compare_text">None</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$earUrl}" alt="Icon">
								<p class="compare_text">Hearing Test and Hearing Protection</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$tapUrl}" alt="Icon">
								<p class="compare_text">Touch sensor</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$batteryUrl}" alt="Icon">
								<p class="compare_text">Up to 6 hours of listening</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$dropUrl}" alt="Icon">
								<p class="compare_text">Water resistant</p>
							</div>
							<div class="compare_block">
								<img src="${$7d2e3f27b298a1f5$var$microphoneUrl}" alt="Icon">
								<p class="compare_text">Dual beamforming microphones</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
  `;
}




function $f96517453f188ce1$export$2c1d9c1fe3e6577a() {
    return `
    ${(0, $7d2e3f27b298a1f5$export$6edbc060ce567afa)()}                                                                                      		
  `;
}




function $ef393588551d13e2$export$5375cda95f0b0eb4() {
    const appMain = document.querySelector(".main");
    const routes = {
        "/": (0, $870eae4dd670dbea$export$b94310965bed44e6),
        "/tech-specs": (0, $65978aa46d2623c0$export$d1b34e3401ad4ae9),
        "/compare": (0, $f96517453f188ce1$export$2c1d9c1fe3e6577a)
    };
    const hash = location.hash.replace("#", "") || "/";
    const page = routes[hash] ? routes[hash]() : "<h1>404 Not Found</h1>";
    appMain.innerHTML = page;
}
window.addEventListener("hashchange", $ef393588551d13e2$export$5375cda95f0b0eb4);
window.addEventListener("load", $ef393588551d13e2$export$5375cda95f0b0eb4); // // Делаем lazy loading (динамический импорт если нужно):
 // export async function router() {
 //   const appMain = document.querySelector(".main");
 //   const hash = location.hash.replace("#", "") || "/";
 //   const routes = {                                                                                 
 //     "/": async () => {
 //       const module = await import("../components/Home/Home.js");
 //       return module.Home();
 //     },
 //     "/page-1": async () => {
 //       const module = await import("../components/Page_1/Page_1.js");
 //       return module.Page_1();
 //     },
 //     "/page-2": async () => {
 //       const module = await import("../components/Page_2/Page_2.js");
 //       return module.Page_2();
 //     },
 //     "/page-3": async () => {
 //       const module = await import("../components/Page_3/Page_3.js");
 //       return module.Page_3();
 //     },
 //   };
 //   const loadPage = routes[hash];                                                                   
 //   if (loadPage) {
 //     appMain.innerHTML = `<p class="loading">Loading...</p>`;                                       
 //     const content = await loadPage();                                                              
 //     appMain.innerHTML = content;                                                                   
 //   } else {
 //     appMain.innerHTML = `<h1>404 Not Found</h1>`;
 //   }
 // }
 // window.addEventListener("hashchange", router);
 // window.addEventListener("load", router);


function $59de1b3cb903d80b$export$2e2bcd8739ae039() {
    const navBtn = document.querySelector('.mobile-nav-btn');
    const nav = document.querySelector('.mobile-nav');
    const menuIcon = document.querySelector('.nav-icon');
    const navLinks = document.querySelectorAll('.mobile-nav a');
    if (!navBtn || !nav) return;
    let scrollY = 0;
    function openMenu() {
        scrollY = window.scrollY;
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        // Фиксируем страницу и компенсируем полосу прокрутки
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.paddingRight = `${scrollBarWidth}px`;
        document.body.classList.add('no-scroll');
        nav.classList.add('mobile-nav--open');
        menuIcon.classList.add('nav-icon--active');
    }
    function closeMenu() {
        // Восстанавливаем прокрутку
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('no-scroll');
        window.scrollTo(0, scrollY);
        nav.classList.remove('mobile-nav--open');
        menuIcon.classList.remove('nav-icon--active');
    }
    function toggleMenu() {
        if (nav.classList.contains('mobile-nav--open')) closeMenu();
        else openMenu();
    }
    navBtn.addEventListener('click', toggleMenu);
    navLinks.forEach((link)=>link.addEventListener('click', closeMenu));
    document.addEventListener('click', (e)=>{
        if (nav.classList.contains('mobile-nav--open') && !nav.contains(e.target) && !navBtn.contains(e.target)) closeMenu();
    });
}


// Отключает переходы по демо-ссылкам (например, href="#" или href="#!")
function $ea4e01622be8838e$export$3cec562cf6373395() {
    document.addEventListener("click", (e)=>{
        const link = e.target.closest("a");
        if (!link) return;
        const href = link.getAttribute("href");
        // Игнорируем пустые или фейковые ссылки
        if (href === "#" || href === "#!" || href === "" || href === "javascript:void(0)") {
            e.preventDefault();
            e.stopPropagation();
            // Для наглядности можно добавить небольшой визуальный эффект (по желанию)
            link.style.transition = "opacity 0.15s ease";
            link.style.opacity = "0.6";
            setTimeout(()=>link.style.opacity = "1", 150);
        }
    });
}


const $f5e5effd96d66274$var$app = document.getElementById("app");
$f5e5effd96d66274$var$app.innerHTML = `
  <div class="wrapper">                                                                            
    ${(0, $59088782b3ab5f20$export$8b251419efc915eb)()}
    <main class="main"></main>                                                                    
    ${(0, $f0715d72829b3571$export$a06f1c675e846f6f)()}
  </div>
`;
(0, $59de1b3cb903d80b$export$2e2bcd8739ae039)();
(0, $ef393588551d13e2$export$5375cda95f0b0eb4)();
(0, $ea4e01622be8838e$export$3cec562cf6373395)();


//# sourceMappingURL=resonance.08805eb2.js.map
